export default "__VITE_ASSET__Ct37ZFMB__"